'use client'
import { CheckedIcon } from '@/features/products/components/icon/rounded-checkbox'
import {
  Stack,
  Step,
  StepConnector,
  stepConnectorClasses,
  StepLabel,
  Stepper,
  styled,
  Typography,
} from '@mui/material'
import dayjs from 'dayjs'

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: '#252422',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: '#252422',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
    // Remove theme.applyStyles if not available
    ...(theme.palette.mode === 'dark' && {
      backgroundColor: theme.palette.grey[800],
    }),
  },
}))

const ColorlibStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean }
}>(({ theme, ownerState }) => ({
  backgroundColor: '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 44,
  height: 44,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(theme.palette.mode === 'dark' && {
    backgroundColor: theme.palette.grey[700],
  }),
  ...(ownerState.active && {
    backgroundColor: '#252422',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundColor: '#252422',
  }),
}))

function ColorlibStepIcon(props: any) {
  const { active, completed, className, icon } = props

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {completed ? (
        <CheckedIcon sx={{ width: 16, height: 16 }} />
      ) : (
        <span style={{ fontWeight: 'bold', fontSize: 16 }}>{icon}</span>
      )}
    </ColorlibStepIconRoot>
  )
}

export const OrderStep = ({ data }: { data: IItemsOrderHistory | IItemsOrderTracking }) => {
  return (
    <Stack
      sx={{
        width: '100%',
        mb: {
          xs: 2,
          md: 4,
        },
      }}
      spacing={{
        xs: 2,
        md: 3,
        lg: 4,
      }}
    >
      <Stepper alternativeLabel connector={<ColorlibConnector />}>
        {data?.timeline?.map((label, index) => (
          <Step key={label?.label} completed={label?.status === 'completed'}>
            <StepLabel
              StepIconComponent={(props) => (
                <ColorlibStepIcon
                  {...props}
                  active={label?.status === 'completed'}
                  completed={label?.status === 'completed'}
                />
              )}
            >
              <Typography
                fontWeight={600}
                sx={{
                  fontSize: {
                    xs: 12,
                    md: 14,
                    lg: 16,
                  },
                }}
              >
                {label?.label}
              </Typography>
              <Typography
                component={'span'}
                fontSize={{
                  xs: 12,
                  md: 14,
                }}
                mt={{
                  xs: 0.5,
                  md: 1,
                }}
              >
                {label.date ? dayjs(label?.date).format('HH:mm DD/MM/YYYY') : ''}
              </Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  )
}
